import { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Card,
  CardContent,
  Tooltip,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import axios from "axios";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { partnergiftCardApi } from "../../app/slices/partnergiftCardSlice";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material";
import { parnerReportCommissionApi } from "../../app/slices/parnerReportCommissionSlice";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axiosInstance from "../../utils/axiosInstance";
const PartnerGiftCard = () => {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(partnergiftCardApi());
  }, [dispatch]);

  const sliceResponse = useSelector(
    (state) => state.partnergiftCard.partnergiftCard.data,
  );
  const stateLoading = useSelector((state) => state.partnergiftCard.loading);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [formData, setFormData] = useState({
    amount: "",
    refinery: "Augmont",
  });
  // console.log("formData: ", formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const validateForm = () => {
    const { amount, refinery } = formData;

    if (!selectedUserName) {
      Swal.fire({
        text: "User Name is required",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }

    if (!refinery) {
      Swal.fire({
        text: "Refinery is required",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }

    // Fix the logic here
    if (!amount) {
      Swal.fire({
        text: "Amount is required",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }

    const numericAmount = parseFloat(amount);
    if (numericAmount <= 0) {
      Swal.fire({
        text: "Amount should be greater than 0",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }

    if (numericAmount % 100 !== 0) {
      Swal.fire({
        text: "Amount should be a multiple of 100",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }

    return true;
  };

  const [partnerData, setpartnerData] = useState([]);

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("partner_id", {
      header: "Partner Id",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.partner_id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.partner_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {/* {cell.row.original?.partner_id} */}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("partner_username", {
      header: "Username",
    }),
    columnHelper.accessor("partnerName", {
      header: "Partner Name",
      Cell: ({ cell }) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            setOpen(true);
            setpartnerData(cell.row.original?.giftdata || "");
          }}
        >
          {" "}
          {cell.row.original?.partnerName}{" "}
        </span>
      ),
    }),

    columnHelper.accessor("amount", {
      header: "Amount",
    }),
    columnHelper.accessor("reminingAmount", {
      header: "Remaining Amount",
    }),

    columnHelper.accessor("refinery", {
      header: "Refinery",
    }),

    // columnHelper.accessor("status", {
    //     header: "status",
    //     Cell: (cell) => cell.row.original.status
    // }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),

    columnHelper.display({
      id: "actions",
      header: "Actions",
      Cell: ({ row }) => {
        const isDeletable = row.original.amount == row.original.reminingAmount;

        return (
          <Box>
            <Tooltip title="Edit">
              <IconButton onClick={() => handleEdit(row.original)}>
                <EditIcon color="primary" />
              </IconButton>
            </Tooltip>

            {isDeletable ? (
              <Tooltip title="Delete">
                <IconButton onClick={() => handleDelete(row.original._id)}>
                  <DeleteIcon sx={{ color: "red" }} />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Cannot delete">
                <span>
                  <IconButton
                    sx={{
                      color: "brown",
                      pointerEvents: "none",
                      opacity: 0.5,
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </span>
              </Tooltip>
            )}
          </Box>
        );
      },

      // Cell: ({ row }) => {
      //     const isDeletable = row.original.amount == row.original.reminingAmount;

      //     return (
      //         <Box>
      //             <Tooltip title="Edit">
      //                 <IconButton onClick={() => handleEdit(row.original)}>
      //                     <EditIcon color="primary" />
      //                 </IconButton>
      //             </Tooltip>

      //             {isDeletable ? (
      //                 <Tooltip title="Delete">
      //                     <IconButton onClick={() => handleDelete(row.original._id)}>
      //                         <DeleteIcon sx={{ color: "red" }} />
      //                     </IconButton>
      //                 </Tooltip>
      //             ) : (
      //                 <Tooltip title="Cannot delete">
      //                     <span>
      //                         <IconButton disabled>
      //                             <DeleteIcon sx={{ color: "brown" }} />
      //                         </IconButton>
      //                     </span>
      //                 </Tooltip>
      //             )}
      //         </Box>
      //     );
      // },
    }),
  ];

  useEffect(() => {
    dispatch(parnerReportCommissionApi());
  }, [dispatch]);

  const sliceResponseOfPartnerList = useSelector(
    (state) => state.parnerReportCommission.parnerReportCommission.data,
  );
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState(""); // For input field
  //   console.log("inputValue: ", inputValue);
  const [filteredOptions, setFilteredOptions] = useState([]); // For filtered results
  const [showDropdown, setShowDropdown] = useState(false); // Dropdown visibility
  const [selectedId, setSelectedId] = useState(""); // Tracks selected option's _id
  // Handle input changes and filter the dropdown list
  const [selectedUserName, setselectedUserName] = useState("");
  //   console.log("selectedUserName: ", selectedUserName);

  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (e) => {
    setFormErrors({});

    const value = e.target.value;
    setInputValue(value);

    // Filter options based on input
    // const filtered = options.filter((option) =>
    const filtered = sliceResponseOfPartnerList?.filter(
      (option) =>
        option?.name.toLowerCase().includes(value.toLowerCase()) ||
        option?.username.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredOptions(filtered || []);

    setShowDropdown(true);
  };

  // Handle focus to show all options initially
  const handleFocus = () => {
    setFormErrors({});

    // setFilteredOptions(options); // Show all options on focus
    setFilteredOptions(sliceResponseOfPartnerList || []); // Show all options on focus
    setShowDropdown(true);
  };

  // Handle selection of an option
  const handleOptionClick = (option) => {
    setInputValue(option?.name); // Set input field to selected name
    setSelectedId(option?._id); // Store the selected _id
    setselectedUserName(option?.username); // Store the selected _id
    setShowDropdown(false);
  };

  // Close dropdown when clicking outside
  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 150); // Delay to allow selection clicks
  };

  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const handleEdit = (rowData) => {
    setIsEditMode(true);
    setEditId(rowData._id);
    setFormData({
      amount: rowData.amount,
      refinery: rowData.refinery,
    });
    setselectedUserName(rowData.partner_username);
    setInputValue(rowData.partnerName);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleSubmit = async () => {
    if (!validateForm()) return;

    setSubmitLoading(true);
    try {
      let response;
      if (isEditMode) {
        response = await axiosInstance.put(
          `/gift/update/allocation/${editId}`, // Replace with your actual update URL
          {
            partner_username: selectedUserName,
            amount: formData.amount,
            refinery: formData.refinery,
          },
          // { headers }
        );
        // response = await axios.put(
        //     `${baseUrl}/gift/update/allocation/${editId}`, // Replace with your actual update URL
        //     {
        //         partner_username: selectedUserName,
        //         amount: formData.amount,
        //         refinery: formData.refinery
        //     },
        //     { headers }
        // );
      } else {
        response = await axiosInstance.post(
          `/gift/allocation`,
          {
            partner_username: selectedUserName,
            amount: formData.amount,
            refinery: formData.refinery,
          },
          // { headers }
        );
        // response = await axios.post(
        //     `${baseUrl}/gift/allocation`,
        //     {
        //         partner_username: selectedUserName,
        //         amount: formData.amount,
        //         refinery: formData.refinery
        //     },
        //     { headers }
        // );
      }

      if (response.data.error === false) {
        Swal.fire({
          text:
            response.data?.message ||
            (isEditMode ? "Updated successfully" : "Submitted successfully"),
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
        });

        // setFormData({ amount: "", });
        setFormData((prev) => ({
          ...prev,
          amount: "",
        }));

        setselectedUserName("");
        setInputValue("");
        setIsEditMode(false);
        setEditId(null);
        dispatch(partnergiftCardApi());
      } else {
        Swal.fire({
          text: response.data?.message || "Something went wrong!",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      Swal.fire({
        text: "Something went wrong",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Partner Gift Card?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await axiosInstance.delete(
          `/gift/delete/allocation/${id}`,
          //      {
          //     headers,
          // }
        );
        // const response = await axios.delete(`${baseUrl}/gift/delete/allocation/${id}`, {
        //     headers,
        // });

        if (response.data.error === false) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Gift card has been deleted.",
            timer: 2000,
            showConfirmButton: false,
          });
          dispatch(partnergiftCardApi());
          // setFormData({ amount: "", });
          setFormData((prev) => ({
            ...prev,
            amount: "",
          }));

          setselectedUserName("");
          setInputValue("");
          setIsEditMode(false);
          setEditId(null);
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed!",
            text: response.data?.message || "Delete failed",
          });
        }
      } catch (error) {
        console.error("Delete error", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    }
  };

  const [open, setOpen] = useState(false);

  return (
    <>
      <Card sx={{ margin: "auto", p: 0, mb: 3, overflow: "visible" }}>
        {/* <Card sx={{ mb: 4Z }}> */}
        <CardContent>
          <Box component="form" onSubmit={(e) => e.preventDefault()}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ position: "relative" }}>
                  <TextField
                    disabled={isEditMode}
                    autoComplete="off"
                    label="Search Partner"
                    // size="small"
                    inputRef={inputRef}
                    value={inputValue}
                    // Autocomplete={false}
                    onChange={handleInputChange}
                    onFocus={handleFocus} // Show all options on focus
                    onBlur={handleBlur}
                    // placeholder="Search Partner"
                    variant="outlined"
                    fullWidth
                    error={!!formErrors.SelectPartner}
                    helperText={formErrors.SelectPartner}
                    InputProps={{
                      sx: {
                        // borderRadius: "8px",
                        // "&:hover": { borderColor: "#007bff" },
                      },
                    }}
                  />

                  {/* Dropdown List */}
                  {showDropdown && (
                    <List
                      sx={{
                        position: "absolute",
                        width: "100%", // Matches TextField width
                        maxHeight: "200px",
                        overflowY: "auto",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                        zIndex: 1301, // High z-index (MUI default modal z-index is 1300)
                        marginTop: "4px",
                        padding: 0,
                      }}
                    >
                      {filteredOptions?.length > 0 ? (
                        filteredOptions?.map((option) => (
                          <ListItem
                            key={option._id}
                            button
                            onMouseDown={() => handleOptionClick(option)}
                            sx={{
                              "&:hover": { backgroundColor: "#f0f0f0" },
                              cursor: "pointer",
                            }}
                          >
                            <ListItemText
                              primary={
                                option?.name ? option?.name : option?.username
                              }
                            />
                            <span style={{ fontSize: 12 }}>
                              {option?.username}
                            </span>
                          </ListItem>
                        ))
                      ) : (
                        <ListItem>
                          <ListItemText
                            primary="No results found"
                            sx={{ color: "#999", fontStyle: "italic" }}
                          />
                        </ListItem>
                      )}
                    </List>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Refinery</InputLabel>
                  <Select
                    fullWidth
                    label="Refinery"
                    name="refinery"
                    // value={formData.refinery}
                    value={formData.refinery || "Augmont"}
                    onChange={handleChange}
                    required
                    disabled
                  >
                    <MenuItem value={"Augmont"}>Augmont</MenuItem>
                    {/* <MenuItem value={"MMTC-PAMP"} >MMTC-PAMP</MenuItem> */}
                    {/* <MenuItem value={"both"} >Both</MenuItem> */}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="number"
                  label="amount"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  required
                />
              </Grid>
              {isEditMode && (
                <Grid item xs={12} sm={3}>
                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    sx={{
                      backgroundColor: "#bc2020 !important", // red color
                      p: { xs: 1, sm: 1.8, md: 1.8 },
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "100%",
                        lg: "100%",
                        xl: "100%",
                      },
                      transition: "transform 0.5s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.01)", // Increase size on hover
                      },
                    }}
                    onClick={() => {
                      setIsEditMode(false);
                      setEditId(null);
                      // setFormData({ amount: "", });
                      setFormData((prev) => ({
                        ...prev,
                        amount: "",
                      }));

                      setInputValue("");
                      setselectedUserName("");
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              )}

              <Grid item xs={12} sm={isEditMode ? 3 : 6}>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  disabled={submitLoading}
                  onClick={handleSubmit}
                  sx={{
                    p: { xs: 1, sm: 1.8, md: 1.8 },
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "100%",
                      lg: "100%",
                      xl: "100%",
                    },
                    transition: "transform 0.5s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.01)",
                    },
                  }}
                >
                  {submitLoading ? "Submitting..." : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="GiftCard"
      />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Gift Code Details
          <Tooltip title="Close">
            <IconButton
              sx={{ float: "right" }}
              onClick={() => setOpen(false)}
              size="small"
            >
              <CloseIcon
                fontSize="inherit"
                color="error"
                sx={{ color: "red" }}
              />
            </IconButton>
          </Tooltip>
        </DialogTitle>
        <DialogContent dividers>
          <TableContainer component={Paper}>
            <Table size="small" aria-label="gift code table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Name</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Email</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Phone</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Gift Code</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Amount</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Metal</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Status</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Expires In</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {partnerData?.map((row) => (
                  <TableRow key={row._id}>
                    <TableCell>{row.name || "-"}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.phone}</TableCell>
                    <TableCell sx={{ display: "flex", alignItems: "center" }}>
                      <Tooltip title="Copy Gift Code">
                        <IconButton
                          size="small"
                          onClick={() => {
                            navigator.clipboard.writeText(row.giftcode);
                            toast.success("copy to clipboard");
                          }}
                        >
                          <ContentCopyIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                      {row.giftcode}
                    </TableCell>
                    {/* <TableCell>{row.giftcode}</TableCell> */}
                    <TableCell>{row.amount}</TableCell>
                    <TableCell>{row.metal_type}</TableCell>
                    <TableCell>{row.status}</TableCell>
                    <TableCell>
                      {new Date(row.expiresin).toLocaleDateString()}
                    </TableCell>
                  </TableRow>
                ))}
                {partnerData?.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No data available.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PartnerGiftCard;
